import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetAnnualCroplandQuery,
  usePublicGetAnnualCroplandQuery,
  useGetAnnualCroplandDefaultsQuery,
  usePublicGetAnnualCroplandDefaultsQuery,
  useUpdateAnnualCroplandMutation
} from '../features/modules/annualCroplandApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting annual cropland data based on the current route.
 */
export const useContextAwareGetAnnualCropland = createContextAwareHook(
  useGetAnnualCroplandQuery,
  usePublicGetAnnualCroplandQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting annual cropland defaults based on the current route.
 */
export const useContextAwareGetAnnualCroplandDefaults = createContextAwareHook(
  useGetAnnualCroplandDefaultsQuery,
  usePublicGetAnnualCroplandDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateAnnualCroplandMutation
}; 